import { CourseProgress } from 'graphqlAPI'
import { getProgressPercentage } from 'components/monitoring/utils'
import { useTranslationRankmi } from 'helpers/translations.helper'
import Progress from '../../../../Progress'
import { prefix } from '../../constants'
import styles from './CoursesProgress.module.scss'

interface CoursesProgressProps {
  progress: CourseProgress[]
}

export const CoursesProgress = ({ progress }: CoursesProgressProps) => {
  const tRelative = useTranslationRankmi({
    prefix,
  })
  const { finish, inProgress, pending } = getProgressPercentage(progress)
  return (
    <>
      <Progress
        className={styles.coursesProgress}
        classes={{
          finish: styles.finish,
          inProgress: styles.inProgress,
          pending: styles.pending,
        }}
        finish={finish}
        inProgress={inProgress}
        pending={pending}
      />
      {tRelative('columns.progress', { count: finish })}
    </>
  )
}
